(() => {
  if (window.__mvCartEnhancementsBound) return;
  window.__mvCartEnhancementsBound = true;

  let lastCartTouchEnd = 0;
  const giftBoxVariantId = 58424094556495;
  const legacySurpriseGiftVariantId = 58483302269263;
  let legacyGiftCleanupInFlight = false;
  let giftUpdateInFlight = false;
  let giftCheckedState = false;

  document.addEventListener('submit', (event) => {
    if (giftUpdateInFlight && ['cart', 'CartDrawer-Form'].includes(event.target.id)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  const syncGiftControls = (busy, checked) => {
    document.querySelectorAll('[data-mv-gift]').forEach((control) => {
      control.checked = checked;
      control.disabled = busy;
      const footer = control.closest('[data-mv-cart-footer], [data-mv-foot]');
      if (footer) {
        footer.classList.toggle('is-busy', busy);
        footer.setAttribute('aria-busy', String(busy));
      }
    });
  };

  const renderCartSections = (data) => {
    if (document.getElementById('main-cart-footer')) {
      window.location.reload();
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      drawer.renderContents(data);
    }
  };

  const removeLegacySurpriseGift = () => {
    if (legacyGiftCleanupInFlight) return;

    legacyGiftCleanupInFlight = true;
    const endpointRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(`${endpointRoot}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart read failed');
        return response.json();
      })
      .then((cart) => {
        const legacyGift = cart.items && cart.items.find(
          (item) => Number(item.variant_id) === legacySurpriseGiftVariantId
        );
        if (!legacyGift) return null;

        return fetch(`${endpointRoot}cart/change.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: legacyGift.key || String(legacySurpriseGiftVariantId),
            quantity: 0,
            sections: ['cart-drawer', 'cart-icon-bubble']
          })
        }).then((response) => {
          if (!response.ok) throw new Error('Legacy gift removal failed');
          return response.json();
        });
      })
      .then((data) => {
        if (data) renderCartSections(data);
      })
      .catch(() => {})
      .finally(() => {
        legacyGiftCleanupInFlight = false;
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeLegacySurpriseGift, { once: true });
  } else {
    removeLegacySurpriseGift();
  }

  const legacyGiftObserver = new MutationObserver(() => {
    if (document.querySelector('a[href*="/products/regalo-sorpresa"]')) {
      removeLegacySurpriseGift();
    }
  });
  legacyGiftObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('touchend', (event) => {
    const drawer = event.target && event.target.closest('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;

    const now = Date.now();
    if (now - lastCartTouchEnd < 320) event.preventDefault();
    lastCartTouchEnd = now;
  }, { passive: false });

  ['gesturestart', 'gesturechange', 'gestureend'].forEach((type) => {
    document.addEventListener(type, (event) => {
      if (document.querySelector('cart-drawer.active')) event.preventDefault();
    }, { passive: false });
  });

  document.addEventListener('touchmove', (event) => {
    if (document.querySelector('cart-drawer.active') && event.touches && event.touches.length > 1) {
      event.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('change', async (event) => {
    const input = event.target && event.target.closest('[data-mv-gift]');
    if (!input) return;

    if (giftUpdateInFlight) {
      syncGiftControls(true, giftCheckedState);
      return;
    }

    giftUpdateInFlight = true;
    const requestedChecked = input.checked;
    giftCheckedState = requestedChecked;
    const endpointRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const endpoint = requestedChecked ? `${endpointRoot}cart/add.js` : `${endpointRoot}cart/change.js`;
    const key = input.getAttribute('data-mv-gift-key');
    const payload = requestedChecked
      ? { items: [{ id: giftBoxVariantId, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'] }
      : { id: key || String(giftBoxVariantId), quantity: 0, sections: ['cart-drawer', 'cart-icon-bubble'] };
    payload.sections_url = window.location.pathname;

    document.querySelectorAll('[data-mv-gift-error]').forEach((error) => { error.hidden = true; });
    syncGiftControls(true, giftCheckedState);
    let resultKnown = false;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) {
          resultKnown = true;
          giftCheckedState = !requestedChecked;
        }
        throw new Error('Gift box update failed');
      }
      const data = await response.json();
      resultKnown = true;
      renderCartSections(data);
    } catch (error) {
      document.querySelectorAll('[data-mv-gift-error]').forEach((message) => {
        message.textContent = resultKnown ? message.dataset.errorLabel : message.dataset.uncertainLabel;
        message.hidden = false;
      });
    } finally {
      giftUpdateInFlight = !resultKnown;
      syncGiftControls(giftUpdateInFlight, giftCheckedState);
    }
  });
})();
